//
//
//
//
//
//

import TinyEditor from "@wenwo-public/tiny-editor-module";
import { getTokenNew } from "@/utils/userStorage.ts";
export default {
  name: "customEditor",
  components: {
    TinyEditor
  },
  props: {
    value: {
      type: String,
      default: ""
    },
    visible: {
      type: [Boolean, Number],
      default: true
    }
  },
  watch: {
    value: {
      handler(newVal, oldVal) {
        if (this.$refs.TinyEditor) {
          this.$refs.TinyEditor.setContent(newVal);
        }
      },
      immediate: true
    }
  },
  computed: {
    content: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("update:value", val);
      }
    },
    show: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit("update:visible", val);
      }
    },
    token: {
      get() {
        console.log("systemToken", getTokenNew());
        return "Bearer business=" + getTokenNew();
      }
    }
  },
  data() {
    return {
      initComplete: true,
      loading: true,
      complete: true,
      editable: true,
      editorInstance: null
    };
  },
  methods: {
    input(content) {
      this.$emit("input", content);
    },
    focus(content) {
      this.$emit("focus", content);
      console.log(content);
    },
    ready(editorInstance) {
      this.editorInstance = editorInstance;
      this.loading = false;
      this.$emit("ready", editorInstance);
    },
    wordCountChange(len) {
      this.$emit("wordCountChange", len);
    },
    contentChange() {
      this.content = this.$refs.TinyEditor.editor.getContent();
      this.$emit("contentChange");
    },
    getContent() {
      return this.$refs.TinyEditor.getValue();
    },
    // 对外透传编辑器关键词搜索，避免业务页面依赖内部组件 ref。
    search(keyword) {
      if (!this.$refs.TinyEditor) return 0;
      const count = this.$refs.TinyEditor.search(keyword);
      // 无匹配时使用仅确认按钮的提示框，避免用户误以为已定位正文。
      if (count === 0) {
        this.$alert(`未找到关键词: ${keyword}`, "提示", {
          confirmButtonText: "确定",
          closeOnClickModal: false,
          closeOnPressEscape: false,
          showClose: false
        });
      }
      return count;
    },
    setContent(c) {
      this.$refs.TinyEditor.setContent(c);
    },
    showMessage(msg) {
      this.editorInstance.notificationManager.open({
        text: msg,
        type: "info",
        timeout: 2000
      });
    },
    getContentLength() {
      return this.$refs.TinyEditor.wordCount;
    }
  },
  mounted() {
    console.log("$attrs", this.$attrs);
    console.log("$listeners", this.$listeners);
  }
};